import {
	BITBUCKET_PIPELINE_PROVIDER_ID,
	BITBUCKET_PIPELINE_PROVIDER_ID_STG,
	BITBUCKET_PROVIDER_ID,
} from './constants.tsx';
import type { Provider, ProviderNamespace } from './types.tsx';

export const isBitbucketPipelineProvider = (provider: Provider): boolean =>
	provider.providerId === BITBUCKET_PIPELINE_PROVIDER_ID ||
	provider.providerId === BITBUCKET_PIPELINE_PROVIDER_ID_STG;

export const isBitbucketSCMProvider = (provider: Provider): boolean =>
	provider.providerId === BITBUCKET_PROVIDER_ID;

export const isJenkinsProvider = (provider: Provider) => {
	if (
		provider.iconUrl !== undefined &&
		provider.iconUrl !== '' &&
		provider.iconUrl.toLowerCase().includes('jenkins')
	)
		return true;
	if (provider.name.toLowerCase().includes('jenkins')) return true;
	return false;
};

// providerId of Bitbucket Pipeline app is not unique, as it is dynamically installed. Unfortunately, we have to rely on its name.
export const isBitbucketProvider = (provider: Provider): boolean =>
	isBitbucketSCMProvider(provider) || isBitbucketPipelineProvider(provider);

type BaseProvider = {
	providerNamespace: ProviderNamespace;
	name: string;
};

export const isOAuthProvider = (provider: BaseProvider): boolean =>
	provider.providerNamespace === 'oauth';

export const hideUGCProviderName = <T extends BaseProvider>(providers: T[]): T[] =>
	providers.map((provider) =>
		isOAuthProvider(provider) ? { ...provider, name: 'UGC provider name hidden' } : provider,
	);
